import React, { Component } from 'react'
import './index.css'
import T from '../../utils/language'
import okIcon from '../../assets/imgs/ok.png'
import noIcon from '../../assets/imgs/no.png'
import { Flex } from 'antd-mobile'
export default class Mqttbox extends Component {
  render() {
    const { mqttInfo, deviceType, system } = this.props
    // system 系统类型(1:安卓 2:无屏)
    const status = mqttInfo.isOnline
    return (
      <div className="mqtt-box">
        {system === 2 && (
          <button
            type="button"
            className="mq-system-detail"
            onClick={this.props.handleDetail}
          >
            {T(`设备详情`)}
          </button>
        )}

        {system === 1 && !!mqttInfo.posKey && (
          <button
            type="button"
            className="mq-system-detail"
            onClick={this.props.handleViewPassword}
          >
            {`${T(`查看密码`)} >>>`}
          </button>
        )}

        <div className="mq-title">
          <h3>{mqttInfo.deviceNo}</h3>
          {system === 2 && (
            <div className={`mq-status ${status ? 'ok' : 'no'}`}>
              <span>MQTT</span>
              <img
                src={status ? okIcon : noIcon}
                alt={`mq-${status ? 'ok' : 'no'}`}
              />
            </div>
          )}

          {deviceType === 5 && system === 2 && (
            <div className={'mq-status battery'}>
              <span>{mqttInfo.powerSupplyMode === 1 ? '电池' : '电源'}</span>
            </div>
          )}
        </div>
        {system === 2 && <div className="p">IMEI: {mqttInfo.deviceImei}</div>}

        <div className="p">
          <Flex>
            {system === 2 && (
              <span style={{ margin: '0 auto 0 5px' }}>
                CSQ: {mqttInfo.csq}
              </span>
            )}

            {system === 1 && (
              <span style={{ margin: '0 auto 0 5px' }}>
                {`${T(`商家`)}:${mqttInfo.businessName || ''}`}
              </span>
            )}

            {mqttInfo.protocolVersion === '2.0' && (
              <button
                className="mq-detail-movement"
                onClick={this.props.movementSystem}
              >
                {T(`机芯配置`)}
              </button>
            )}
            {system === 2 && (
              <button className="mq-detail" onClick={this.props.resetSystem}>
                {T(`远程重启`)}
              </button>
            )}
          </Flex>
        </div>
        {mqttInfo.supportPos === 1 && (
          <div className="p">
            <Flex>
              <span style={{ margin: '0 auto 0 5px' }}>
                {`${T(`刷卡机`)}:${mqttInfo.posSerialNo || ''}`}
              </span>

              <button
                className="mq-detail-movement mq-popup-pos"
                onClick={this.props.popupPOS}
              >
                {T(`弹出POS机`)}
              </button>
            </Flex>
          </div>
        )}
      </div>
    )
  }
}
